module.exports = __webpack_public_path__ + "static/media/status.af36ade0.png";